import { observer } from 'mobx-react-lite'
import { KnowledgeBase } from 'pages/settings/pages/knowledgeBase/pages/knowledgeBaseView/KnowledgeBase'

export const KnowledgeBaseViewPage = observer(() => {
  return <KnowledgeBase />
})
